import React from 'react';
import {CustomDropDown} from '../../../../manageOrders/components/internalCommons/customDropDown';
import {CURRENCY_LIST} from '../../../constants';
import CurrencyInput from 'react-currency-input-field';
import moment from 'moment';

export const columnsPrices = () => {
  return [
    /* {
      'Header': () => <span className='header-title'>ID</span>,
      'accessor': 'groupId',
    }, */
    {
      'Header': () => <span className='header-title'>CÓDIGO EXTERIOR</span>,
      'accessor': 'outdoorColor',
    },
    {
      'Header': () => <span className='header-title'>COLOR EXTERIOR</span>,
      'accessor': 'outdoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>CÓDIGO INTERIOR</span>,
      'accessor': 'indoorColor',
    },
    {
      'Header': () => <span className='header-title'>COLOR INTERIOR</span>,
      'accessor': 'indoorColorDescription',
    },
    {
      'Header': () => <span className='header-title'>TIPO COLOR</span>,
      'accessor': 'colorTypeDescription',
    },
    {
      'Header': () => <span className='header-title'>MONEDA</span>,
      'accessor': 'currency',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <CustomDropDown
          className={'prices-custom-input-small'}
          value={initialValue}
          onChange={(e, {value}) => handleChange(value)}
          options={CURRENCY_LIST}
        />;
      },
    },
    {
      'Header': () => <span className='header-title'>FOB</span>,
      'accessor': 'fob',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='FOB'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>FLETE</span>,
      'accessor': 'shippingCost',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='FLETE'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>VALOR COLOR</span>,
      'accessor': 'colorValue',
      'Cell': ({
        'value': initialValue,
        'row': {index, original},
        'column': {id},
        updateMyData,
      }) => {
        const item = original;
        const handleChange = (value) => {
          updateMyData(index, id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!item.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={initialValue}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='VALOR COLOR'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>COMISIÓN</span>,
      'accessor': 'commission',
      'Cell': ({row, column, updateMyData}) => {
        const handleChange = (value) => {
          updateMyData(row.index, column.id, value);
        };
        return <div className='ui input input-price'>
          <CurrencyInput
            className={`prices-custom-input-small ${!row.original?.priceId && 'disabled-custom'}`}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={row.original?.commission || 0}
            onValueChange={(value, _) => handleChange(value)}
            placeholder='COMISIÓN'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>C&F</span>,
      'accessor': 'cif',
      'Cell': ({row}) => {
        return <div className='ui input input-price'>
          <CurrencyInput
            className={'prices-custom-input-small disabled-custom'}
            prefix="$ "
            decimalSeparator=","
            groupSeparator="."
            decimalsLimit={2}
            value={row.original?.cif || 0}
            placeholder='C&F'
          />
        </div>;
      },
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD.&nbsp;INICIO</span>,
      'accessor': 'startDate',
      'Cell': ({
        'row': {original},
      }) => {
        const item = original;
        return <>{item.startDate ? moment(item.startDate).format('MM/YYYY') : ''}</>;
      },
    },
    {
      'Header': () => <span className='header-title'>FECHA PROD. FIN</span>,
      'accessor': 'endDate',
      'Cell': ({
        'row': {original},
      }) => {
        const item = original;
        return <>{item.endDate ? moment(item.endDate).format('MM/YYYY') : ''}</>;
      },
    },
  ];
};
